import { productsData } from "src/data/productsData";
import ProductCard from "../../shared/productcard/ProductCard/ProductCard";
import s from "./ExploreProducts.module.scss";

const ExploreProducts = ({ numOfProducts = -1, customization }) => {
  const filteredProducts = productsData.filter((_, i) => i > numOfProducts);

  return (
    <div className={s.products}>
      {filteredProducts.map((product) => (
        <ProductCard
          product={product}
          key={product.id}
          customization={customization}
        />
      ))}
    </div>
  );
};
export default ExploreProducts;
